// extracted by mini-css-extract-plugin
export default {"tableContainer":"src-pages-SalesChannelCategory-ProductCategory-Card-css-module__tableContainer--WaZ-K"};